"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactFilm = require("react-film");

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _CarouselFilmStrip = _interopRequireDefault(require("./CarouselFilmStrip"));

var _useDirection3 = _interopRequireDefault(require("../hooks/useDirection"));

var _useLocalizer = _interopRequireDefault(require("../hooks/useLocalizer"));

var _useStyleSet3 = _interopRequireDefault(require("../hooks/useStyleSet"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ROOT_CSS = (0, _glamor.css)({
  overflow: 'hidden',
  position: 'relative'
});

var CarouselLayout = function CarouselLayout(_ref) {
  var activity = _ref.activity,
      children = _ref.children,
      nextVisibleActivity = _ref.nextVisibleActivity;

  var _useStyleSet = (0, _useStyleSet3.default)(),
      _useStyleSet2 = _slicedToArray(_useStyleSet, 1),
      carouselFlipperStyleSet = _useStyleSet2[0].carouselFlipper;

  var _useDirection = (0, _useDirection3.default)(),
      _useDirection2 = _slicedToArray(_useDirection, 1),
      direction = _useDirection2[0];

  var filmStyleSet = (0, _reactFilm.createBasicStyleSet)({
    cursor: null
  });
  var leftSideFlipper = direction === 'rtl' ? '>' : '<';
  var localize = (0, _useLocalizer.default)();
  var rightSideFlipper = direction === 'rtl' ? '<' : '>';
  return _react.default.createElement(_reactFilm.Composer, {
    dir: direction,
    numItems: _react.default.Children.count(children)
  }, _react.default.createElement(_reactFilm.Context.Consumer, null, function (_ref2) {
    var scrollBarWidth = _ref2.scrollBarWidth;
    return _react.default.createElement("div", {
      className: (0, _classnames.default)(ROOT_CSS + '', filmStyleSet.carousel + '')
    }, _react.default.createElement(_CarouselFilmStrip.default, {
      activity: activity,
      nextVisibleActivity: nextVisibleActivity
    }, children), scrollBarWidth !== '100%' && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactFilm.Flipper, {
      "aria-label": localize('CAROUSEL_FLIPPER_LEFT_ALT'),
      blurFocusOnClick: true,
      className: (0, _classnames.default)(carouselFlipperStyleSet + '', filmStyleSet.leftFlipper + ''),
      mode: "left"
    }, _react.default.createElement("div", {
      className: "button"
    }, leftSideFlipper)), _react.default.createElement(_reactFilm.Flipper, {
      "aria-label": localize('CAROUSEL_FLIPPER_RIGHT_ALT'),
      blurFocusOnClick: true,
      className: (0, _classnames.default)(carouselFlipperStyleSet + '', filmStyleSet.rightFlipper + ''),
      mode: "right"
    }, _react.default.createElement("div", {
      className: "button"
    }, rightSideFlipper))));
  }));
};

CarouselLayout.defaultProps = {
  children: undefined,
  nextVisibleActivity: undefined
};
CarouselLayout.propTypes = {
  activity: _propTypes.default.any.isRequired,
  children: _propTypes.default.any,
  nextVisibleActivity: _propTypes.default.any
};
var _default = CarouselLayout;
exports.default = _default;